export default [
    {
        path: '/',
        name: 'root',
        // redirect: '/home'
        component: () => import('@/views/cmon/Login.vue')
    },
    // 홈 화면
    {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/cmon/Home.vue')
    },
    // 로그인 화면
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/cmon/Login.vue')
    },
    // // 비밀번호 변경 인증 화면
    // {
    //     path: '/chngPswdAuth',
    //     name: 'chngPswdAuth',
    //     component: () => import('@/views/cmon/chngPswdAuth.vue')
    // },
    // // 비밀번호 변경 화면
    // {
    //     path: '/chngPswdSet',
    //     name: 'chngPswdSet',
    //     component: () => import('@/views/cmon/chngPswdSet.vue')
    // },
    
]